import CardCommon from '@op/components/CardCommon';
import React, { useMemo, useState } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import useCompareKeyMetricsColumns from '@op/components/TableCommonHook/hooks/useCompareKeyMetricsColumns';
import {
  GameStoreOneOptionsType,
  GameStoreTwoOptionsType,
  MentionsSentimentSubSortType,
  TableHeight,
} from '../../constants';
import { useCompareKeyMetricsTable } from '../../hooks';
import { dealWithMobileGameStoreTable } from '../../utils';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
export default function PRTable({
  filter,
  store,
  type,
  gameData,
}: {
  filter: any;
  store: GameStoreOneOptionsType;
  type: GameStoreTwoOptionsType;
  gameData: {
    [id: string]: {
      name: string;
      color: string;
    };
  }[];
}) {
  const { downloadLegacy, downloading } = useDownloadParams();

  const params = useMemo(
    () => ({
      ...filter,
      stats_types: ['game_store'],
      tab_type: store,
      by_type: type,
    }),
    [filter, store, type],
  );

  const { tableRecords, loading } = useCompareKeyMetricsTable({
    filter: params,
    dealwithToTable: dealWithMobileGameStoreTable,
    gameData,
    defaultSortKey: 'mentions',
  });

  const { columns, sortColumns } = useCompareKeyMetricsColumns({
    oneKey: 'GameStore',
    twoKey: store,
    threeKey: type,
    tableRecords,
    gameData,
    filter,
  });

  return (
    <CardCommon
      contentCard
      className="mentions-sentiment-table-wrapper"
      hasDownload
      loading={loading}
      loadingHeight={265}
      downloadLoading={downloading}
      handleDownloadOnClick={() => {
        downloadLegacy({
          params: {
            ...params,
            gameData,
          },
          downloadFunc: 'getOverviewCompetitorTable',
          sheetName: 'Compare Key Metrics Game Store Table',
          simpleName: 'Compare Key Metrics Game Store Table',
        });
      }}
      logBtnId={'Mobile Game Store Table'}
    >
      <TableCommonHook
        columns={columns}
        bordered="all"
        hasPageable={false}
        sortColumns={sortColumns}
        maxHeight={TableHeight.BELOW}
        records={tableRecords}
        sortType={'local'}
        logBtnId={'Mobile Game Store'}
      ></TableCommonHook>
    </CardCommon>
  );
}
